export default __webpack_public_path__ + "static/media/impact-icon.5b647003.svg";